<template>
	<div class="news">
		<banner title="新闻资讯" :img="sty" />
		<div class="news-section" v-loading="loading">
			<h2>行业新闻</h2>
			<div class="new_div">
				<div class="new_conter" v-for="(item,index) in list1" :key="index" @click="linkrouter(item.uuid)">
					<div style="height:100%"><img :src="item.img" alt="" /></div>
					<div class="new_p">
						<p class="p1">{{item.p1}}</p>
					</div>
					<div class="new_bottom">
						<div class="new_b1">{{item.d1}}</div>
						<div class="new_b2">{{item.d2}}</div>
					</div>
				</div>
			</div>
			<h2>集团新闻</h2>
			<div class="new_div">
				<div class="new_conter" v-for="(item,index) in list2" :key="index" @click="linkrouter(item.uuid)">
					<div style="height:100%"><img :src="item.img" alt="" /></div>
					<div class="new_p">
						<p class="p1">{{item.p1}}</p>
					</div>
					<div class="new_bottom">
						<div class="new_b1">{{item.d1}}</div>
						<div class="new_b2">{{item.d2}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Banner from "../components/Banner";
	export default {
		name: "news",
		components: {
			Banner,
		},
		data() {
			return {
				sty: {},
				list1: [
					// {
					// 	img: require('@/assets/home/new1.png'),
					// 	p1: '为长三角更高质量一体化发展注入新动能',
					// 	p2: " 东南形胜，今更胜昔。长三角是我国经济最发达的区域之一，外贸体量更是占到全国的35%......",
					// 	d1: '查看详情',
					// 	d2: '2020-5-20'
					// }

				],
				list2: [
					// {
					// 	img: require('@/assets/home/new1.png'),
					// 	p1: '为长三角更高质量一体化发展注入新动能',
					// 	p2: " 东南形胜，今更胜昔。长三角是我国经济最发达的区域之一，外贸体量更是占到全国的35%......",
					// 	d1: '查看详情',
					// 	d2: '2020-5-20'
					// }
				
				],
				// img:' backgroundImage:@/assets/home/banner.png',
				loading: false,
				newsList: [],
				newstype: 1,
			};
		},
		methods: {
			linkrouter(a) {
				var route = '/publicPage?uuid=' + a;
				this.$router.push(route);
			},
			// loadData() {
			// 	this.loading = true;
			// 	this.$http
			// 		.get(`News?type=${this.newstype}&num=6`)
			// 		.then((response) => {
			// 			//console.log(response);
			// 			this.newsList = response.data;
			// 			this.loading = false;
			// 			//window.console.log(this.newsList);
			// 		})
			// 		.catch(function(error) {
			// 			window.console.log(error);
			// 		});
			// },
			//banner图
			getlunbo() {
				var that = this;
				that.$axios({
					method: "get",
					url: "system/pcmanage/list",
					// data: this.$qs.stringify(data)
					params: {
						location:2
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if(res.data.result == 200){
						console.log(res.data)
						var data = res.data.detail;
						that.sty = {
							backgroundImage: "url(" + data[0].showpath + ")",
						}
					}
					
				})
			},
			getlist(){
				var that = this;
				that.$axios({
					method: "post",
					url: "webpc/pcnewsmessige/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
						page:1,
						pagesize:50000
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						var list = data.list;
						// console.log(list);
						that.list1 = [];
						that.list2 = [];
						for (var i = 0; i < list.length; i++) {
							if(list[i].msgtype == 0){
								that.list1.push({
									img: list[i].showpath,
									p1: list[i].title,
									p2: list[i].descp,
									d1: '查看详情',
									d2: list[i].createtime.slice(0, 10),
									uuid: list[i].uuid
								})
							}
							if(list[i].msgtype == 1){
								that.list2.push({
									img: list[i].showpath,
									p1: list[i].title,
									p2: list[i].descp,
									d1: '查看详情',
									d2: list[i].createtime.slice(0, 10),
									uuid: list[i].uuid
								})
							}
						}
					}
				
				})
				
			}
		},
		mounted() {
			// this.loadData();
			this.getlist();
			this.getlunbo();
		},
		watch: {
			// newstype(type) {
			// 	window.console.log(type);
			// 	this.loadData();
			// },
		},
	};
</script>

<style lang="scss" scoped>
	* {
		margin: 0;
		padding: 0;
	}

	.news {
		width: 100%;
		height: 100%;

		position: relative;
		overflow: hidden;

		.news-section {
			width: 62.5%;
			height: 100%;
			margin: auto;
			padding-bottom: 40px;

			img {
				width: 100%;
				height: 100%;
			}

			h2 {
				margin: 20px 0;
			}

			.new_div {
				width: 100%;
				height: 100%;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				// grid-template-rows: 2fr 1fr;
				grid-row-gap: 20px;
				grid-column-gap: 20px;
				.new_conter {
					display: grid;
					width: 100%;
					height: 100%;
					grid-template-rows: 6fr 3fr 1fr;
					border: 1px solid #e5e5e5;
					.new_p {
						.p1 {
							font-size: 18px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #2f2f2f;
							line-height: 19px;
							text-align: center;
							padding: 10px;
						}
						.p2 {
							font-size: 14px;
							font-family: Microsoft YaHei;
							padding: 10px;
							font-weight: 400;
							color: #636363;
							line-height: 24px;
						}
					}
					.new_bottom {
						display: grid;
						border-top: 1px solid #e5e5e5;
						grid-template-columns: 1fr 1fr;
						align-items: center;
						.new_b1 {

							font-size: 12px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #8D8D8D;
							line-height: 19px;
							padding-left: 10px
						}

						.new_b2 {

							font-size: 12px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #8D8D8D;
							line-height: 19px;
							text-align: right;
							padding-right: 20px;
						}
					}
				}
			}
		}
	}
</style>
